import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError, AxiosResponse} from 'axios'
import {httpUpdateFollowUp, HttpUpdateFollowUpOptions} from './treatment-requests.http'
import {FollowUp} from '@/features/treatment-requests/types'

export const useUpdateFollowUp = ({
    urlParams,
    options
}: {
    urlParams: HttpUpdateFollowUpOptions['urlParams']
    options?: UseMutationOptions<AxiosResponse<FollowUp>, AxiosError<unknown>, HttpUpdateFollowUpOptions['payload']>
}) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.UPDATE_FOLLOW_UP],
        mutationFn: payload =>
            httpUpdateFollowUp({
                urlParams,
                payload
            })
    })
